module.exports = __webpack_public_path__ + "img/undo-alt.eaa0a508.svg";